module.exports = __webpack_public_path__ + "img/paypal-logo.d3d63373.svg";